export default {
    streams: []
}